// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#map {
    height: 700px;
    width: 100%;
}

.info {
    padding: 6px 8px;
    font: 14px/16px Arial, Helvetica, sans-serif;
    background: white;
    background: rgba(255, 255, 255, 0.8);
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
}

.info h4 {
    margin: 0 0 5px;
    color: #777;
}
`, "",{"version":3,"sources":["webpack://./assets/src/ipha/ipha_map.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,4CAA4C;IAC5C,iBAAiB;IACjB,oCAAoC;IACpC,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;AACf","sourcesContent":["#map {\n    height: 700px;\n    width: 100%;\n}\n\n.info {\n    padding: 6px 8px;\n    font: 14px/16px Arial, Helvetica, sans-serif;\n    background: white;\n    background: rgba(255, 255, 255, 0.8);\n    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);\n    border-radius: 5px;\n}\n\n.info h4 {\n    margin: 0 0 5px;\n    color: #777;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
